export default __webpack_public_path__ + "static/media/testimonial.29da7ff8.svg";